import iglesiaBackground from 'assets/img/casa_de_la_vila.png'
import logoRodo from 'assets/img/logo-redondo-aj-monjos.png'
import { useUser } from 'contexts/UserContext'
import LoginForm from 'forms/login/loginForm'
import useFetch from 'hooks/useFetch'
import { useEffect, useState } from 'react'
import { useLocation } from 'wouter'

export default function Login() {
  const { setUser } = useUser()
  const [, setLocation] = useLocation()
  const [requestedLogin, requestLogin] = useFetch()
  const [loginError, setLoginError] = useState(null)

  const handleSubmitLogin = async (values) => {
    const apiCallParams = {
      url: 'auth/login',
      method: 'POST',
      body: values,
      messageKo: 'Usuari i/o contrasenya incorrectes'
    }
    await requestLogin(apiCallParams)
  }

  useEffect(() => {
    if (requestedLogin.data) {
      setLocation('/')
      setLoginError(null)
      setUser(requestedLogin.data)
    }
  }, [requestedLogin.data])

  useEffect(() => {
    if (requestedLogin.isCalled) {
      if (requestedLogin.error) {
        setLoginError('Usuari o contrasenya incorrectes!')
      }
    }
  }, [requestedLogin.loading])

  return (
    <div className="bg-white">
      <div className="flex justify-center h-screen">

        {/* Columna esquerra: foto de l'església sense overlay */}
        <div
          className="hidden lg:block lg:w-2/3"
          style={{
            backgroundImage: `url(${iglesiaBackground})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }}
        />

        {/* Columna dreta: formulari */}
        <div className="flex items-center w-full max-w-md px-6 mx-auto lg:w-2/6">
          <div className="flex-1">
            <div className="text-center">
              <div className="flex justify-center mx-auto">
                <img
                  className="w-auto h-28"
                  src={logoRodo}
                  alt="Ajuntament de Santa Margarida i els Monjos"
                />
              </div>

              <p className="mt-3 text-gray-500 dark:text-gray-300">
                Iniciï sessió per accedir al seu compte.
              </p>
            </div>

            <div className="mt-8">
              <LoginForm
                loginError={loginError}
                handleSubmit={handleSubmitLogin}
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
